module.exports = __webpack_public_path__ + "img/widget-3.9493d784.png";